import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';
import InvoiceRepository from '../repositories/InvoiceRepository';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import CompanyBillingDetailsRepository from '../repositories/CompanyBillingDetailsRepository';

class SaveInvoiceDetailsUseCase extends TransactionLoadHandler {
  private invoiceRepository: InvoiceRepository;

  private companyBillingDetailsRepository: CompanyBillingDetailsRepository;

  constructor(options?: ITransactionLoad) {
    super(options?.transactionLoadOptions);
    this.invoiceRepository = diContainer.get(serviceNames.invoiceRepository);
    this.companyBillingDetailsRepository = diContainer.get(serviceNames.companyBillingDetailsRepository);
  }

  protected async run(): Promise<void> {
    try {
      const {
        invoiceRepository,
        companyBillingDetailsRepository: { formStore },
      } = this;

      const companyBillingDetails = formStore.toCompanyBillingDetails();
      await invoiceRepository.updateInvoiceDetails(companyBillingDetails);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}

export default SaveInvoiceDetailsUseCase;
